import Layout from 'components/Layout'
import { Route, Switch } from 'react-router-dom'
import { routes } from 'utils/constants'
import { Checkout } from '../pages/Checkout'
import Cobranca from '../pages/Cobranca'
import OrderStatus from '../pages/OrderB2c/OrderStatus'
import RepresentativeSuccess from '../pages/Pagaleve/RepresentativeSuccess'
import RepresentativeError from '../pages/Pagaleve/RepresentativeError'

const Routes = () => {
  return (
    <Switch>
      <Layout>
        <Route exact path={routes.B2B_ORDER_STATUS_USER} component={OrderStatus} />
        <Route exact path={routes.CHECKOUT} component={Checkout} />
        <Route path={routes.PAGAMENTO} component={Cobranca} />
        <Route exact path={routes.PAGALEVE_REP_SUCCESS} component={RepresentativeSuccess} />
        <Route exact path={routes.PAGALEVE_REP_ERROR} component={RepresentativeError} />
      </Layout>
    </Switch>
  )
}

export default Routes
